import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { withTheme } from "emotion-theming"
import VisuallyHidden from "@reach/visually-hidden"

import { ViewButton } from "@components/button"
import { Row, Col } from "@components/grid"
import Panel from "@components/panel"

import { Round } from "@components/image"
import Keyline from "@components/keyline"
import { Strong } from "@components/type"

const sectionTitle = "Executive Director & President of the Board's Message"

const Executive = ({ theme }) => (
  <section>
    <Panel maxWidth="1200px" background={theme.color}>
      <h1>{sectionTitle}</h1>
      <Row>
        <Col width={[1, 3 / 4]}>
          <p>
            Change is expected in life and can bring with it many challenges,
            both professionally and personally. This past year has definitely
            been one of changes here at Neighbour to Neighbour Centre, but
            through change we see growth, opportunity and new beginnings.
          </p>
          <p>
            In 2018, we were saddened to see three longtime employees leave the
            organization. Clare Wagner, Manager of Community Food, who was an
            integral part in the creation of the Hamilton Community Food Centre,
            moved to Kitchener-Waterloo. Our longtime Manager of Administrative
            Services, Linda Jagodich retired and moved out west to spend more
            time with her family. Samantha Lycklama our Accounting Associate
            left to pursue new endeavors as an entrepreneur.
          </p>
        </Col>
        <Col width={[1, 1 / 4]}>
          <StaticQuery
            query={graphql`
              query {
                file(
                  relativePath: {
                    eq: "home/exectutive-director-and-president.jpg"
                  }
                ) {
                  childImageSharp {
                    fixed(width: 200) {
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
            `}
            render={data => <Round fixed={data.file.childImageSharp.fixed} />}
          />
          <p>
            <Strong>Katherine Livingstone</Strong>
            <br />
            Board President
          </p>
          <Keyline colour={theme.backgroundColor} />
          <p>
            <Strong>Denise Arkell</Strong>
            <br />
            Executive Director
          </p>
        </Col>
      </Row>
      <ViewButton to="/message" colour={theme.backgroundColor}>
        View
        <VisuallyHidden> {sectionTitle}</VisuallyHidden>
      </ViewButton>
    </Panel>
  </section>
)

export default withTheme(Executive)
